import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomSavedCartsModule } from './saved-carts/custom-saved-carts.module';
import { ConfigModule, AuthGuard } from '@spartacus/core';
import { customFacadeProviders } from './facade.provider';
import { UserAccountConnector } from '@spartacus/user/account/core';
import { CustomAddressBookModule } from './custom-address-book/custom-address-book.module';
import { DatePickerService } from '@spartacus/storefront';
import { CustomDatepickerService } from '@services/custom-datepicker.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CustomSavedCartsModule,
    CustomAddressBookModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AccountMyQuotesComponent: {
          component: () =>
            import('./custom-quote-history/custom-quote-history.component').then(
              (m) => m.CustomQuoteHistoryComponent
            ),
          guards: [AuthGuard],
        },
        AccountAddressBookComponent: {
          component: () =>
            import('./custom-address-book/book/book.component').then((m) => m.BookComponent),
          guards: [AuthGuard],
        },
        AccountSavedCartHistoryComponent: {
          component: () =>
            import('./saved-carts/custom-saved-cart-list/saved-cart-list.component').then(
              (m) => m.CustomSavedCartListComponent
            ),
          guards: [AuthGuard],
        },
        UpdateProfileComponent: {
          component: () =>
            import('./custom-profile/custom-update-profile/custom-update-profile.component').then(
              (m) => m.CustomUpdateProfileComponent
            ),
          guards: [AuthGuard],
        },
        SelectB2bUnitComponent: {
          component: () =>
            import('./custom-select-b2bunit/custom-select-b2bunit.component').then(
              (m) => m.CustomSelectB2bunitComponent
            ),
          guards: [AuthGuard],
        },
        AccountOrderHistoryComponent: {
          component: () =>
            import('./custom-order-history/custom-order-history.component').then(
              (m) => m.CustomOrderHistoryComponent
            ),
          guards: [AuthGuard],
        },
        AccountOrderDetailsOverviewComponent: {
          component: () =>
            import('./custom-order-details-overview/custom-order-details-overview.component').then(
              (m) => m.CustomOrderDetailsOverviewComponent
            ),
          guards: [AuthGuard],
        },
        AccountOrderDetailsItemsComponent: {
          component: () =>
            import('./custom-order-details-items/custom-order-details-items.component').then(
              (m) => m.CustomOrderDetailsItemsComponent
            ),
          guards: [AuthGuard],
        },
        AccountOrderDetailsTotalsComponent: {
          component: () =>
            import('./custom-order-details-totals/custom-order-details-totals.component').then(
              (m) => m.CustomOrderDetailsTotalsComponent
            ),
          guards: [AuthGuard],
        },
        AccountOrderDetailsActionsComponent: {
          component: '',
          guards: [AuthGuard],
        },
        SavedCartDetailsOverviewComponent: {
          component: () =>
            import('./custom-cart-details-overview/custom-cart-details-overview.component').then(
              (m) => m.CustomCartDetailsOverviewComponent
            ),
          guards: [AuthGuard],
        },
        SavedCartDetailsItemsComponent: {
          component: () =>
            import('./custom-cart-details-items/custom-cart-details-items.component').then(
              (m) => m.CustomCartDetailsItemsComponent
            ),
          guards: [AuthGuard],
        },
        SavedCartDetailsActionComponent: {
          component: () =>
            import('./custom-cart-details-actions/custom-cart-details-actions.component').then(
              (m) => m.CustomCartDetailsActionsComponent
            ),
          guards: [AuthGuard],
        },
        AccountQuoteDetailsOverviewComponent: {
          component: () =>
            import('./custom-quote-detail-overview/custom-quote-detail-overview.component').then(
              (m) => m.CustomQuoteDetailOverviewComponent
            ),
          guards: [AuthGuard],
        },
        QuoteDetailsEntriesComponent: {
          component: () =>
            import('./custom-quote-detail-entries/custom-quote-detail-entries.component').then(
              (m) => m.CustomQuoteDetailEntriesComponent
            ),
          guards: [AuthGuard],
        },
        QuoteTotalsComponent: {
          component: () =>
            import('./custom-quote-detail-totals/custom-quote-detail-totals.component').then(
              (m) => m.CustomQuoteDetailTotalsComponent
            ),
          guards: [AuthGuard],
        }
      },
    }),
  ],
  providers: [
    UserAccountConnector,
    ...customFacadeProviders,
    { provide: DatePickerService, useClass: CustomDatepickerService },
  ],
})
export class CustomMyaccountModule {}
